module.exports = __webpack_public_path__ + "media/images/map-image-responsive-d4dc93e9bf3e863d99e3951f7e500838.png";